import api from '~/services/api';

export const fetchFeatureTests = () =>
  api.request({
    method: 'GET',
    url: '/ui/features',
  });
